<template>
  <section>
    <div class="container">
      <div class="handle-box">
        <router-link :to="{ path: '/server/add', query: { id: 0 } }">
          <el-button size="small" type="primary" icon="el-icon-plus" v-if="!$route.query.id">添加</el-button>
        </router-link>
      </div>
      <el-table :data="tableData" stripe @selection-change="checkIds" v-loading="loading">
        <el-table-column
          type="selection"
          width="55"
          align="right"
        ></el-table-column>
        <el-table-column
          prop="sid"
          label="ID"
          align="center"
          v-if="false"
        ></el-table-column>
        <el-table-column prop="server_name" label="服务器名" align="center"></el-table-column>
        <el-table-column prop="server_code" label="编号" align="center"></el-table-column>
        
        <el-table-column prop="server_ip" label="IP地址" align="center"></el-table-column>
        <el-table-column prop="server_port" label="端口号" align="center"></el-table-column>
        <el-table-column prop="stype_name" label="服务器类型" align="center"></el-table-column>
        <el-table-column prop="name" label="操作" align="center" v-if="!$route.query.id">
          <div slot-scope="scope">
            <router-link
              :to="{ path: '/server/update', query: { id: scope.row.sid } }"
            >
              <el-button class="ml10" type="text" icon="el-icon-edit"
                >修改</el-button
              >
            </router-link>
            <el-button
              type="text"
              icon="el-icon-delete"
              class="red ml10"
              @click="del('Server/Delete', scope.row.sid)"
              >删除</el-button
            >
          </div>
        </el-table-column>
      </el-table>
      <!-- 表格底部 -->
      <div class="cms-list-footer">
        <div class="cms-left">
          <el-button
            size="small"
            :disabled="disabled"
            @click="deleteBatch('Server/Delete', ids)"
            >批量删除</el-button
          >
        </div>
        <!-- 分页组件 -->

        <cms-pagination :total="total" @change="getPages"></cms-pagination>
      </div>
    </div>
  </section>
</template>

<script>
import listMixins from "@/mixins/list";

export default {
  name: "Server",
  mixins: [listMixins],
  data() {
    return {
      params: {
        //只需要业务参数
        pageNo: "1",
        pageSize: "10"
      }
    };
  },
  mounted() {},
  methods: {
    checkIds(val) {
      let ids = [];
      for (let i in val) {
        ids.push(val[i].sid);
      }
      this.ids = ids.join(",");
      this.disabled = val.length > 0 ? false : true;
      this.checkedList = val;
    },
    del(val1, val2) {
      this.deleteBatch(val1, val2);
    }
  },
  created() {
    //获取信息
    //传入参数id时，只能查看不能修改该服务器类型下的服务器
    this.params.stid=this.$route.query.id;
    this.initTableData("Server/PagedView", this.params);
  },
  watch: {
    // 修复增改设备之后，重新加载页面，无法执行 created  函数
    $route(to,from){
      this.initTableData("Server/PagedView", this.params);
    }
  }
};
</script>
